"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBytesToFilesize = exports.formatAsWholeNumberString = exports.formatAsCompactString = exports.formatAsDecimalString = exports.formatAsPercentageString = void 0;
/**
 * Formats a decimal number as a percentage string
 * @param value - A decimal number
 * @param options - Optional formatting options
 * @returns A formatted percentage string (e.g., "50%")
 * @throws Error if the input value is not a number
 */
const formatAsPercentageString = (value, options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
}) => {
    if (isNaN(value) || !isFinite(value)) {
        throw new Error('Value must be a number');
    }
    return `${(value * 100).toLocaleString('en-US', options)}%`;
};
exports.formatAsPercentageString = formatAsPercentageString;
/**
 * Formats a number as a decimal string
 * @param value - The number to format as decimal
 * @param options - Optional formatting options for decimal places
 * @returns A formatted decimal string (e.g., "1,234.56")
 */
const formatAsDecimalString = (value, options) => {
    const defaultOptions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };
    const finalOptions = Object.assign(Object.assign({}, defaultOptions), options);
    return new Intl.NumberFormat('en-US', finalOptions).format(value);
};
exports.formatAsDecimalString = formatAsDecimalString;
/**
 * Formats a number as a compact string with K/M suffixes
 * @param value - The number to format
 * @param options - Optional formatting options
 * @returns A formatted compact string (e.g., "1.5K", "2.4M")
 */
const formatAsCompactString = (value, options) => {
    const { fallbackValue = '-', decimalPlaces = 1 } = options || {};
    if (value === null || value === undefined)
        return fallbackValue;
    if (value >= 1000000) {
        return `${(value / 1000000).toFixed(decimalPlaces)}M`;
    }
    if (value >= 1000) {
        const thousands = value / 1000;
        const rounded = parseFloat(thousands.toFixed(decimalPlaces));
        // If rounding pushes us to 1000K or higher, convert to millions
        if (rounded >= 1000) {
            return `${(value / 1000000).toFixed(decimalPlaces)}M`;
        }
        return `${thousands.toFixed(decimalPlaces)}K`;
    }
    return value.toString();
};
exports.formatAsCompactString = formatAsCompactString;
/**
 * Formats a number as a whole number string with comma separators
 * @param value - The number to format
 * @param options - Optional formatting options
 * @returns A formatted whole number string (e.g., "1,234", "5,400,000")
 */
const formatAsWholeNumberString = (value, options) => {
    const { fallbackValue = '-' } = options || {};
    if (value === null || value === undefined)
        return fallbackValue;
    return Math.round(value).toLocaleString('en-US');
};
exports.formatAsWholeNumberString = formatAsWholeNumberString;
const formatBytesToFilesize = (bytes) => {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
exports.formatBytesToFilesize = formatBytesToFilesize;
